import angular from "angular";
import DashboardCtrl from "./DashboardCtrl.js";

export default angular.module("antes.dashboard", [])
    .config(function routing($urlRouterProvider, $locationProvider, $stateProvider) {
        //$locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/');
        $stateProvider
            .state("home",{
                url:"/",
                template: require("./home.html"),
                controller: DashboardCtrl,
                controllerAs: "ctrl",
                resolve: DashboardCtrl.$resolve
            })
    })
    .name


// WEBPACK FOOTER //
// ./src/customer-portal/dashboard/index.js